import RecoveredBlackboards from './RecoveredBlackboards';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { pendingDirectRecordings } from '../../utils/directRecordingUpload';

const MeetingEnded = () => {
  const navigate = useNavigate();
  const role = useSelector(state => state.auth?.user?.role);
  const canRecover = ['admin', 'super_admin', 'superadmin', 'church_admin', 'staff', 'faculty'].includes(String(role).toLowerCase());
  const params = useParams();
  const location = useLocation();
  const roomId = params.roomId || location.state?.roomId || '';
  const [pending, setPending] = useState([]);
  const [saved, setSaved] = useState(false);
  useEffect(() => {
    let mounted = true;
    const refresh = () => pendingDirectRecordings(roomId, { includeActive: true }).then(rows => { if (mounted) setPending(rows); }).catch(() => {});
    const changed = event => {
      if (roomId && event.detail?.roomId !== roomId) return;
      if (event.detail?.state === 'completed') setSaved(true);
      void refresh();
    };
    void refresh(); const timer = window.setInterval(refresh, 3000);
    window.addEventListener('meeting-recording-direct-status', changed);
    return () => { mounted = false; window.clearInterval(timer); window.removeEventListener('meeting-recording-direct-status', changed); };
  }, [roomId]);

  useEffect(() => {
    sessionStorage.setItem('meetingEnd', 'end');
    sessionStorage.removeItem('rejoinStatus');
    sessionStorage.removeItem('rejoin-room');
    sessionStorage.removeItem('lastRoomId');

    const currentPath = window.location.pathname + window.location.search;
    window.history.replaceState(null, '', currentPath);

    const handlePopState = () => {
      window.history.pushState(null, '', currentPath);
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50 px-6 text-center">
      <div className="w-full max-w-md rounded-2xl bg-white p-8 shadow-xl">
        <div className="mb-4 text-5xl">📞</div>
        <h1 className="mb-4 text-3xl font-bold text-gray-900">Meeting Ended</h1>
        <p className="text-gray-600">The meeting has ended.</p>
        {roomId && <p className="mt-2 text-xs text-gray-400">Room: {roomId}</p>}
        {pending.length > 0 && <div className="mt-5 rounded-xl bg-amber-50 p-4 text-left text-sm text-amber-900" role="status">
          <strong>Recording save is still pending</strong>
          <p className="mt-1">Your recording is kept in this browser. Uploads retry automatically when the connection is available. Keep this tab open until Recording saved appears.</p>
          {pending.map(row => <div key={row.id} className="mt-3"><span>{row.title || 'Class recording'}</span><progress className="block w-full" max={row.totalBytes || 1} value={row.uploadedBytes || 0} aria-label="Recorded bytes saved" />
            {row.recoveryBlocked && <p>Upload needs attention. Open Recording uploads to review and retry.</p>}</div>)}
        </div>}
        {!pending.length && saved && <p role="status" className="mt-5 rounded-xl bg-green-50 p-4 text-green-800">Recording saved.</p>}
        <button
          type="button"
          onClick={() => navigate('/', { replace: true })}
          className="mt-7 rounded-lg bg-blue-600 px-5 py-2.5 font-medium text-white hover:bg-blue-500"
        >
          Return to Home
        </button>
        {canRecover && <button type="button" className="mt-4 block w-full rounded-lg border border-gray-300 px-4 py-2 text-gray-700" onClick={() => window.dispatchEvent(new CustomEvent('meeting-recording-uploads-open'))}>Recording uploads</button>}
      </div>
      <RecoveredBlackboards />
    </div>
  );
};

export default MeetingEnded;
